'use strict';

import * as _ from 'lodash';



export function FirebaseService($location, $http, $cookies, $q, appConfig, Util, User, $firebaseAuth, $rootScope, baseConfigService) {
  'ngInject';

  var safeCb = Util.safeCb;
  var currentUser = {};
  var role;
  var userRoles = appConfig.userRoles || [];
  var adminBaseURL = baseConfigService.getAdminBaseURL();
  /**
   * Check if userRole is >= role
   * @param {String} userRole - role of current user
   * @param {String} role - role to check against
   */
  var hasRole = function(userRole, role) {
    return userRoles.indexOf(userRole) >= userRoles.indexOf(role);
  };

  // If access token exists, get user information
  if($cookies.get('token') && $location.path() !== '/logout') {
    $http.get(`${adminBaseURL}/users/me/toc_app`)
          .then(user => {
            currentUser = user.data;
            role = currentUser.role;
            // $rootScope.currentUser = user.data[0];
          })
          .catch(err => {
            console.log(err);
            $location.path('/');
            $cookies.remove('token');
            $rootScope.currentUser = {};
          });
  }

  var FB = {
    /**
     * Authenticate user and save token
     *
     * @param  {Object}   user     - login info
     * @param  {Function} callback - function(error, user)
     * @return {Promise}
     */
    login({
      email,
      password
    }, callback) {
      return $firebaseAuth().$signInWithEmailAndPassword(email, password)
        .then(res => {
          $cookies.put('token', res.Dd);
          return $http.get(`${adminBaseURL}/firebase/callback`)
          .then(response => {
            $cookies.remove('token');
            console.log("the login response: ", response.data);
            if(response.data){
              $cookies.put('token', response.data);
              return this.getCurrentUser();
            } else {
              const message = 'This user is not active. Please contact us...';

              $rootScope.login_error = message;
              return $q.reject(new Error(message));

            }

          })
          .catch(err => {
            console.log("the error: ", err);
          });

        })
        .catch(err => {
          console.log('the error before logout', err);
          $rootScope.login_error = err.message || err;
          FB.logout();
          safeCb(callback)(err);
          return $q.reject(err);
        });
    },

    /**
     * Delete access token and user info on logout
     */
    logout() {
      $cookies.remove('token');
      $firebaseAuth().$signOut();
      currentUser = {}; //Reset user
    },

    /**
     * Create a new user
     *
     * @param  {Object}   user     - user info
     * @param  {Function} callback - function(error, user)
     * @return {Promise}
     */
    createUser(user, callback) {
     /**
      * Add user to firebase using email and password
      */
      return $firebaseAuth().$createUserWithEmailAndPassword(user.email, user.password)
      .then(firebaseUser => {
     /**
      * Send verification email to user once added to Firebase
      */
      firebaseUser.sendEmailVerification()
      .catch((error) =>{
        //error code
        var errorCode = error.code

        //error message
        var errorMessage = error.message
    })

      /**
       * Add new user to Socrata table
       */
      var socrataUser = {
        id: firebaseUser.uid,
        email: firebaseUser.email,
        firstname: user.firstname,
        lastname: user.lastname,
        organization: user.organization
      }

      return $http.post(`${adminBaseURL}/users/new`, socrataUser)
      .then(response => {

      })
      .catch(err => {
        console.log(err);
      })
    })
    .catch(error => {
      console.error("Error creating user:", error);
      // Handle the error appropriately; display error message to the user
      throw error; // Re-throw to propagate the error down the chain if needed
    })
  },
    // createUser(user, callback) {
    //   return User.save(user, function(data) {
    //     $cookies.put('token', data.token);
    //     currentUser = User.get();
    //     return safeCb(callback)(null, user);
    //   }, function(err) {
    //     Auth.logout();
    //     return safeCb(callback)(err);
    //   })
    //     .$promise;
    // },

    /**
     * Change password
     *
     * @param  {String}   oldPassword
     * @param  {String}   newPassword
     * @param  {Function} callback    - function(error, user)
     * @return {Promise}
     */
    changePassword(oldPassword, newPassword, callback) {
      return User.changePassword({
        id: currentUser._id
      }, {
        oldPassword,
        newPassword
      }, function() {
        return safeCb(callback)(null);
      }, function(err) {
        return safeCb(callback)(err);
      })
        .$promise;
    },

    setCurrentUser(userData) {
      console.log('Setting current user:', userData); // Debug line

      return new Promise((resolve, reject) => {
        // If userData is provided, use it directly
        if (userData) {
          currentUser = userData;
          $rootScope.currentUser = userData;
          $rootScope.$broadcast('userDataUpdated', userData);
          return resolve(currentUser);
        }


        // Otherwise fetch from backend
        $http.get(`${adminBaseURL}/users/me/toc_app`)
          .then(response => {
            console.log('User data fetched:', response.data); // Debug line

            currentUser = response.data;
            $rootScope.currentUser = currentUser;

            // Store in cookies if needed
            $cookies.putObject('user', currentUser);

            // Broadcast update
            $rootScope.$broadcast('userDataUpdated', currentUser);

            resolve(currentUser);
          })
          .catch(err => {
            console.error('Error setting current user:', err);
            reject(err);
          });
      });
    },

    /**
     * Gets all available info on a user
     *
     * @param  {Function} [callback] - function(user)
     * @return {Promise}
     */
    getCurrentUser() {
      // Return cached user if available
      if (currentUser) {
        return Promise.resolve(currentUser);
      }

      // Otherwise fetch from backend
      return this.setCurrentUser();
    },

    clearCurrentUser() {
      currentUser = null;
      $rootScope.currentUser = null;
      $cookies.remove('user');
      $rootScope.$broadcast('userDataUpdated', null);
    },

    /**
     * Gets all available info on a user
     *
     * @return {Object}
     */
    getCurrentUserSync() {
      return currentUser;
    },

    /**
     * Check if a user is logged in
     *
     * @param  {Function} [callback] - function(is)
     * @return {Promise}
     */
    isLoggedIn(callback) {
      return FB.getCurrentUser(undefined)
        .then(user => {
          let is = _.get(user, 'role');

          safeCb(callback)(is);
          return is;
        });
    },

    /**
     * Check if a user is logged in
     *
     * @return {Bool}
     */
    isLoggedInSync() {
      return !!_.get(currentUser, 'role');
    },

    /**
     * Check if a user has a specified role or higher
     *
     * @param  {String}     role     - the role to check against
     * @param  {Function} [callback] - function(has)
     * @return {Promise}
     */
    hasRole(role, callback) {
      return FB.getCurrentUser(undefined)
        .then(user => {
          let has = hasRole(_.get(user, 'role'), role);

          safeCb(callback)(has);
          return has;
        });
    },

    /**
     * Check if a user has a specified role or higher
     *
     * @param  {String} role - the role to check against
     * @return {Bool}
     */
    hasRoleSync(role) {
      return hasRole(_.get(currentUser, 'role'), role);
    },

    /**
     * Check if a user is an admin
     *   (synchronous|asynchronous)
     *
     * @param  {Function|*} callback - optional, function(is)
     * @return {Bool|Promise}
     */
    isAdmin(...args) {
      return FB.hasRole(Reflect.apply([].concat, ['Administrator'], args));
    },

    /**
     * Check if a user is an admin
     *
     * @return {Bool}
     */
    isAdminSync() {
      // eslint-disable-next-line no-sync
      return FB.hasRoleSync('User');
    },

    /**
     * Get auth token
     *
     * @return {String} - a token string used for authenticating
     */
    getToken() {
      return $cookies.get('token');
    }
  };

  return FB;
}



// WEBPACK FOOTER //
// ./client/components/auth/firebase.service.js